module.exports = "/img/service-2.0feabcab.png";